export { QuickEditComponent } from './quick-edit.component'
export enum OnChangeType {
  Toggle,
  Reload,
}

export interface OnChange {
  type: OnChangeType;
  data?: any | undefined;
}


